/*
 * @Description: 请求处理
 * @Author: xiawenlong
 * @Date: 2020-12-16 19:57:59
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-07-15 11:24:08
 */
import axios from 'axios'
import codeMsg from './code-msg'
import { getDashboardToken, clearDashboardToken, emitTokenInvalid } from './dashboard-auth'
// import { getCookie } from '@/utils/cookies'
// 大屏登录失效错误码
const TOKEN_INVALID_CODE = 987989
// 需要注入 dashboardToken 的大屏弹窗接口
const TOKEN_REQUIRED_URLS = [
  '/dashboard/live/list', // 直播弹窗
  '/dashboard/biz/order/page', // 批发成交弹窗
  '/dashboard/user/order/page', // 零售成交弹窗
  '/dashboard/third/order/page', // 零售成交弹窗(第三方)
  '/dashboard/get/area/sale/total', // 新型农村集体经济组织弹窗
  '/dashboard/onsale/material/page', // 商品数量弹窗
  '/dashboard/group/material/page', // 商品数量弹窗(校园餐)
  '/dashboard/biz/supplier/page', // 供应商数量弹窗
  '/dashboard/biz/cus/page', // 企业客户数量弹窗
  '/dashboard/user/cus/page', // 个人客户数量弹窗
]
class Http {
  constructor() {
    this.baseURL = process.env.VUE_APP_BASE_API
    // this.timeout = 5000
  }
  setInterceptor(instance) {
    instance.interceptors.request.use(
      config => {
        // 仅大屏弹窗接口在请求体注入 dashboardToken
        if (config.method === 'post' && TOKEN_REQUIRED_URLS.some(url => config.url.includes(url))) {
          const token = getDashboardToken()
          if (token) {
            config.data = { ...(config.data || {}), dashboardToken: token }
          }
        }
        return config
      },
      error => {
        return Promise.reject(error)
      },
    )
    instance.interceptors.response.use(
      response => {
        const { code } = response.data
        switch (~~code) {
          case 0:
            return response.data
          case TOKEN_INVALID_CODE:
            // 大屏登录已失效，清除 token 并通知弹登录
            clearDashboardToken()
            emitTokenInvalid()
            return Promise.reject(response.data)
          default:
            return Promise.reject(response.data)
        }
      },
      error => {
        const { status = 404 } = error.response
        if (Object.prototype.hasOwnProperty.call(codeMsg, status)) {
          this.errorHandler(error, codeMsg[status])
        }
        throw error
      },
    )
  }
  // 异常处理器
  errorHandler(error, msg) {
    if (process.env.NODE_ENV === 'development') {
      console.group('❌ HTTP Error')
      console.log('错误信息：' + msg)
      console.log('接口地址：' + error.response.config.url)
      console.log(error)
      console.groupEnd()
    } else {
      return Promise.reject(error)
    }
  }
  mergeOptions(options) {
    return {
      baseURL: this.baseURL,
      timeout: this.timeout,
      ...options,
    }
  }
  request(options) {
    const instance = axios.create()
    const opts = this.mergeOptions(options)
    this.setInterceptor(instance)
    return instance(opts)
  }
  get(url, config = {}) {
    return this.request({
      method: 'get',
      url,
      ...config,
    })
  }
  post(url, data, config) {
    return this.request({
      method: 'post',
      url,
      data,
      ...config,
    })
  }
}
export default new Http()
